import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledToastContainer = styled(Flex)(({ theme }) => ({
  '.Toastify__toast-theme--colored.Toastify__toast--default': {
    color: theme.palette.toastText.success,
    backgroundColor: theme.palette.success[100],
  },
  '.Toastify__toast-theme--colored.Toastify__toast--info': {
    color: theme.palette.toastText.info,
    backgroundColor: theme.palette.info[100],
  },
  '.Toastify__toast-theme--colored.Toastify__toast--warning': {
    color: theme.palette.toastText.warning,
    backgroundColor: theme.palette.warning[100],
  },
  '.Toastify__toast-theme--colored.Toastify__toast--error ': {
    color: theme.palette.toastText.error,
    backgroundColor: theme.palette.error[100],
  },
  '.Toastify__toast-theme--colored.Toastify__toast--success': {
    color: theme.palette.toastText.success,
    backgroundColor: theme.palette.success[100],
    border: `1px solid ${theme.palette.primary[500]}`,
  },
  '.Toastify__toast': {
    paddingTop: 5,
    paddingBottom: 5,
    minHeight: 20,
    minWidth: 'auto',
    boxShadow: 'none',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.Toastify__toast-body': {
    fontSize: '0.875rem',
    fontFamily: 'Inter',
    fontWeight: 400,
    minWidth: 'auto',
    textTransform: 'none',
  },
}));
